export default {
  getCustomerServiceRating: (state) => state.customerServiceRating,
};
